export enum HttpCodes {
  UNAUTHORIZED = 401,
  BAD_REQUEST = 400,
  INTERNAL_SERVER_ERROR = 500,
  PAYLOAD_TOO_LARGE = 413,
}
